import { inject, Injectable } from '@angular/core';
import { TokenTypes } from '@r1-compass-library/services/login.service';
import { CookieService } from 'ngx-cookie-service';

@Injectable({ providedIn: 'root' })
export class LoginCookieService {
    readonly #cookieService = inject(CookieService);

    // JWT
    getJWTCookie() {
        return this.#cookieService.get(TokenTypes.Jwt);
    }
    setJWTCookie(value: string) {
        this.#cookieService.set(TokenTypes.Jwt, value, undefined, '/', undefined, true, 'Strict');
    }
    hasJWTCookie() {
        return this.getJWTCookie()?.length > 0;
    }

    // Division Token
    getDivTokenCookie() {
        return this.#cookieService.get(TokenTypes.Div);
    }
    setDivTokenCookie(value: string) {
        this.#cookieService.set(TokenTypes.Div, value, undefined, '/', undefined, true, 'Strict');
    }
    hasDivTokenCookie() {
        return this.getDivTokenCookie()?.length > 0;
    }

    resetAllCookies() {
        this.#cookieService.deleteAll('/');
    }
}
